import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';

type HasExtensionParams = {
  extensionKey: string;
};

/**
 * Checks if a specific extension has been applied to the Dynamic client.
 *
 * Extensions add optional features to the Dynamic SDK,
 * such as EVM, Solana, or other chain support.
 *
 * @param params.extensionKey - The unique key identifying the extension to check for.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if the extension is applied, false otherwise.
 */
export const hasExtension = (
  { extensionKey }: HasExtensionParams,
  client = getDefaultClient()
) => {
  const core = getCore(client);

  return core.extensions.has(extensionKey);
};
